<div>
  <nz-table
    #nzTable
    class="v4-layout-list"
    [nzFrontPagination]="false"
    [nzData]="listOfLink"
    [nzTotal]="total"
    [(nzPageIndex)]="page"
    [nzPageSize]="pageSize"
    nzPaginationType="small"
    [nzShowTotal]="totalTpl"
    (nzPageIndexChange)="onPageChange($event)">
    <thead>
      <tr>
        <th>{{ "shared-link_html_th_link" | translate }}</th>
        <th>{{ "shared-link_html_th_property" | translate }}</th>
        <th></th>
      </tr>
    </thead>
    <tbody class="v4-layout-list-body">
      <tr *ngFor="let row of nzTable.data">
        <td class="whitespace-nowrap">
          {{ row.link }}
          <span
            class="cursor-pointer ml-2"
            hostClipboard
            [clipboardData]="row.link"
            nz-icon
            nzType="copy"
            nzTheme="outline"></span>
        </td>
        <td>
          {{ row.house.no_limit ? "All" : row.house.members.join("、") }}
        </td>
        <td>
          <button nz-button (click)="onDelete(row.id)">{{ "word.delete" | translate }}</button>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <ng-template #totalTpl>{{ "component-page_html_总数" | translate: { number: total } }}</ng-template>
</div>
